// extracted by mini-css-extract-plugin
export default {"zoomModal":"F4-z"};